import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';
import { FrequencyValue } from '@kaizenplatform/kaizen-chartjs';

export const setIndexReportFrequency = (indexReportFrequency: FrequencyValue) =>
  produce((draft: Draft<State>) => {
    draft.indexReportFrequency.data = indexReportFrequency;
  });

export const disposeIndexReportFrequency = () =>
  produce((draft: Draft<State>) => {
    draft.indexReportFrequency.data = initialState.indexReportFrequency.data;
  });
